import React, { useEffect, useState } from "react";
import "./styles/PageTemplate.scss";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLangNavigate } from "../hooks/useLangNavigate";
type Props = {
  title: string;
  titleColor?: string;
  menuList: { name: string; link: string }[];
  backgroundImage?: string | string[];
};
const PageTemplate = ({ title, titleColor, menuList, backgroundImage }: Props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const langNavigate = useLangNavigate();
  const [tap, setTap] = useState(0);

  const getPathWithoutLang = () => {
    const path = window.location.pathname;
    return path.replace(/^\/(ko|en)/, "");
  };
  useEffect(() => {
    const index2 = menuList.findIndex((item) => item.link === getPathWithoutLang());
    setTap(index2);
  }, [location.pathname]);
  const handleTap = (link: string) => {
    langNavigate(link);
  };

  const [size, setSize] = useState(250);
  useEffect(() => {
    const handleResize = () => {
      setSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const imageSize = () => {
    return size > 1024 ? "01" : size > 768 ? "02" : "03";
  };
  return (
    <>
      <div className="page_template_wrap">
        <h2
          className="banner"
          style={{
            backgroundImage: `url(${backgroundImage}_${imageSize()}.png)`,
            color: `${titleColor}`,
          }}
        >
          {title}
        </h2>
        <div className="tap_wrap">
          <ul>
            {menuList.map((list: { name: string; link: string }, index: number) => {
              return (
                <li key={`${list.name}_${index}`} id={String(index)} className={`${tap === index ? "active" : ""}`} onClick={() => handleTap(list.link)}>
                  {t(list.name)}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default PageTemplate;
